import { combineEpics } from 'redux-observable';
import { errorEpic, successEpic, cancelEpic, modalShownEpic } from './callbacks/index.tsx';
import { epic as deleteVersionEpic } from './delete-version/index.tsx';
import { epic as getRelatedIssuesCountEpic } from './get-related-issues-count/index.tsx';
import { epic as showOrDeleteEpic } from './show-dialog-or-delete/index.tsx';

export default combineEpics(
	getRelatedIssuesCountEpic,
	deleteVersionEpic,
	errorEpic,
	successEpic,
	cancelEpic,
	modalShownEpic,
	showOrDeleteEpic,
);
